import store from '@/store'

export const featureAccess = {
  farm: ['FARM', 'FARM_EDIT'],
  proc: [
    'SHIPMENT', 'SHIPMENT_EDIT',
    'LOT', 'LOT_EDIT'
  ],
  brand: ['BATCH', 'BATCH_CSV_UPLOAD'],
  system: [
    'FARM', 'FARM_EDIT',
    'SHIPMENT', 'SHIPMENT_EDIT',
    'LOT', 'LOT_EDIT',
    'BATCH', 'BATCH_CSV_UPLAOD'
  ]
}

export const tabs = {
  farm: [
    { key: 'farms', description: 'Farms' }
  ],
  proc: [
    { key: 'shipments', description: 'Shipments' },
    { key: 'lots', description: 'Lots' }
  ],
  brand: [
    { key: 'batches', description: 'Mixing Batches' },
    { key: 'lots', description: 'Lots' },
    { key: 'shipments', description: 'Shipments' },
    { key: 'farms', description: 'Farm List' }
  ],
  system: [
    { key: 'farms', description: 'Farm List' },
    { key: 'lots', description: 'Lots' },
    { key: 'batches', description: 'Mixing Batches' },
    { key: 'shipments', description: 'Shipments' }
  ]
}

export function getFirstAllowedTab () {
  if (!store.getters.profile || !store.getters.profile.organization) {
    return '/'
  }
  return tabs[store.getters.profile.organization.role][0].key
}

export function checkTabAccess (to, from, next) {
  if (isAllowedInTab(to.name)) {
    next()
  } else {
    next(getFirstAllowedTab())
  }
}

export function canAccess (feature) {
  if (!store.getters.profile || !store.getters.profile.organization) {
    return false
  }

  return ~featureAccess[store.getters.profile.organization.role].indexOf(feature)
}

export function isAllowedInTab (tab) {
  if (!store.getters.profile || !store.getters.profile.organization) {
    return false
  }
  return tabs[store.getters.profile.organization.role].find((t) => {
    return t.key === tab
  })
}
